export default __webpack_public_path__ + "static/Verde36-6b3b6c166962ca4b2c0df5389613533f.png";